import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { Usager } from '@app/models/consumer';
import { DemarcheItem, DemarcheStep } from '@app/models/demarche';
import { FamilyService, PermissionService } from '@app/services';
import { someFromIndex } from '@app/utils/array';

@Component({
  selector: 'app-demarche-select-step',
  templateUrl: './demarche-select-step.component.html',
  styleUrls: ['./demarche-select-step.component.scss'],
  standalone: false
})
export class DemarcheSelectStepComponent implements OnInit {

  @Input() demarche: DemarcheItem;
  @Input() stepper: MatStepper;
  @Input() step: DemarcheStep;
  @Input() index: number;
  @Output() onValidate = new EventEmitter<Usager>();
  @Output() onCreate = new EventEmitter<'Enfant' | 'Conjoint'>();
  isDisabled: boolean;
  listUsagers: Usager[];
  selectedUsager: Usager;
  conjointExist: boolean;
  permToAddChild: boolean;
  permToEditFoyer: boolean;

  constructor(
    private familyService: FamilyService,
    private permService: PermissionService
  ) { }

  ngOnInit(): void {
    this.permToAddChild = this.permService.hasPermission('child_create');
    this.permToEditFoyer = this.permService.hasPermission('foyer_edit');
    this.isDisabled = this.isUsagerLinkedToOtherStep();
    this.loadData();
  }

  loadData() {
    this.familyService.getListUsagers(this.familyService.currentFamily.id).subscribe(usagers => {
      this.listUsagers = usagers;
      this.conjointExist = this.listUsagers.find(usager => usager.estConjoint) ? true : false;

      if (this.step?.usagerSelected?.id != null && this.step?.usagerSelected?.type) {
        const match = this.listUsagers.find(u =>
          u.id === this.step.usagerSelected.id &&
          u.type === this.step.usagerSelected.type
        );
        if (match) {
          this.selectedUsager = match;
        }
      }
    })
  }

  isUsagerLinkedToOtherStep(): boolean {
    if (this.step.usagerSelected) {
      return someFromIndex(
        this.demarche.steps,
        this.index,
        (step, i) => step.type === 'form' && (step?.usagerSelected?.id === this.step.usagerSelected.id) && (step?.usagerSelected?.type === this.step.usagerSelected.type));
    }
    return false;
  }

  onClickToAdd(formName: 'Enfant' | 'Conjoint') {
    this.onCreate.emit(formName)
  }

  onValider() {
    if (!this.selectedUsager) return;
    this.onValidate.emit(this.selectedUsager);
  }

}
